import { h } from "preact";
import { useState, useRef, useEffect } from "preact/hooks";
import { CSSTransition } from "react-transition-group";
import ProductOptions from "../product-options/product-options";
import QuantityInput from "../../global/quantity-input/quantity-input-react";

export default function ProductAddonContent({
  open,
  id,
  productId,
  idPrefix,
  initialVariantId,
  selectedVariant,
  setSelectedVariant,
  quantity,
  setQuantity,
  added,
  setAdded,
}) {
  const [height, setHeight] = useState(0);
  const nodeRef = useRef();
  const roRef = useRef(null);

  useEffect(() => {
    return () => roRef.current?.disconnect();
  }, []);

  // The panel stays mounted while collapsed so the shopper's variant, quantity
  // and added state survive closing and reopening it.
  return (
    <CSSTransition
      in={open}
      nodeRef={nodeRef}
      classNames="product-addon__content-"
      onEntering={() => {
        if (!nodeRef.current) return;
        const inner = nodeRef.current.firstElementChild;
        if (!inner) return;
        roRef.current = new ResizeObserver(() => {
          if (nodeRef.current) setHeight(nodeRef.current.scrollHeight);
        });
        roRef.current.observe(inner);
      }}
      onEntered={() => {
        roRef.current?.disconnect();
        roRef.current = null;
      }}
      onExited={() => {
        roRef.current?.disconnect();
        roRef.current = null;
      }}
      addEndListener={(done) => {
        const node = nodeRef.current;
        if (!node) return;
        const onEnd = (event) => {
          if (event.target !== node || event.propertyName !== "height") return;
          node.removeEventListener("transitionend", onEnd);
          done();
        };
        node.addEventListener("transitionend", onEnd, false);
      }}
    >
      <div
        className="product-addon__content"
        id={id}
        ref={nodeRef}
        inert={!open}
        style={{ "--height": `${height}px` }}
      >
        <div className="product-addon__content-inner">
          <ProductOptions
            productId={productId}
            idPrefix={idPrefix}
            initialVariantId={initialVariantId}
            optionsRole="secondary"
            selectedVariant={selectedVariant}
            setSelectedVariant={setSelectedVariant}
            truncate={true}
          />
          <div className="product-addon__actions">
            <QuantityInput
              className="product-addon__quantity"
              quantity={quantity}
              setQuantity={setQuantity}
              allowZero={true}
            />
            <label className="product-addon__toggle toggle-label">
              <div className="toggle-wrapper">
                <input
                  type="checkbox"
                  checked={added}
                  onChange={() => setAdded(!added)}
                />
                <span className="toggle-icon product-addon__toggle-icon"></span>
              </div>
              <span className="product-addon__toggle-text caption-2">
                {added
                  ? window.localeStrings.product.addon_added
                  : window.localeStrings.product.addon_add_to_product}
              </span>
            </label>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
}
